












































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import SkriningMppPage from "@/components/mpp/SkriningMppPage.vue";
import PerencanaanMppPage from "@/components/mpp/PerencanaanMppPage.vue";
import ImplementasiMppPage from "@/components/mpp/ImplementasiMppPage.vue";
import mppModule from "@/store/modules/MppStore";

@Component({
  components: {
    SkriningMppPage,
    PerencanaanMppPage,
    ImplementasiMppPage
  }
})
export default class MppPage extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: string;

  // Kontrol Tab
  activeTab = "tab-skrining";

  get isLoadingData() {
    return mppModule.loading;
  }

  async mounted() {
    await this.loadMppData();
    await this.loadSkriningOption();
  }

  @Watch("register")
  onRegisterChange() {
    if (this.register) {
      this.loadMppData();
    }
  }

  async loadMppData() {
    if (!this.register) return;
    try {
      await mppModule.fetchAllMpp(this.register);
    } catch (error) {
      console.error("Gagal memuat data Mpp : ", error);
    }
  }

  async loadSkriningOption() {
    await mppModule.fetchSkriningOptions();
  }
}
